import React from 'react';

import Select from '../common/Select';

const BoolSelector = ({ onValueChange, value }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'baseline',
    }}
  >
    <Select
      className="ant-select-border-bottom"
      style={{ width: 120 }}
      multi={false}
      customizable={false}
      useJSON
      onChange={onValueChange}
      value={value}
      values={['true', 'false']}
      getPopupContainer={(triggerNode) => triggerNode}
      virtual={false}
    />
  </div>
);

export default BoolSelector;
